module.exports = {"140181001":"东曲街道","140181002":"西曲街道","140181003":"桃园街道","140181004":"屯兰街道","140181100":"河口镇","140181101":"镇城底镇","140181102":"马兰镇","140181200":"阁上乡","140181201":"加乐泉乡","140181202":"梭峪乡","140181203":"岔口乡","140181204":"常安乡","140181205":"原相乡","140181206":"邢家社乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140181.json
// module id = 269
// module chunks = 0